<script lang="ts">
    import * as Card from '@/components/ui/card';
    import HarnessTable from './HarnessTable.svelte';
    import { Button } from '@/components/ui/button';
    import { Plus } from 'lucide-svelte';
    import type { Snippet } from 'svelte';
    import type Blocks from '@/schemas/public/Blocks';
    import type { Field } from '@/types/types';

    type Props = {
        employeeId: string;
        onOpenCreate?: () => void;
        onRowClick?: (row: any) => void;
        children?: Snippet;
        blocks?: (Blocks & { fields: Field[] })[];
        id?: string;
        refetch?: () => Promise<void>;
    };

    let { employeeId, onOpenCreate, onRowClick, children, blocks = [], id = '', refetch = $bindable() }: Props = $props();
</script>


{#snippet harnessTableHeader()}
    {#if onOpenCreate}
        <Button
            onclick={onOpenCreate}
            class="flex items-center gap-x-3 rounded-lg px-3 py-2 text-sm font-medium hover:bg-accent"
        >
            <Plus class="h-4 w-4" />
            Add Harness
        </Button>
    {/if}
{/snippet}
<HarnessTable
    title="Harness & Lanyards"
    view="relatedList"
    relatedData={{
        column: 'employee_id',
        record_id: employeeId,
    }}
    {onRowClick}
    headerSnippet={harnessTableHeader}
    {id}
    bind:refetch
/>


{@render children?.()}
